export const pt = {
    seo: {
        title: 'MyCarCosts | Ultimate Car Expense Tracker & Repair Analysis',
        description: 'Track car maintenance, expenses, and history. Use our AI-powered repair vs sell analyzer to make data-driven decisions about your vehicle.'
    },
    common: {
        back: "Voltar",
        save: "Salvar",
        saved: "Salvo",
        cancel: "Cancelar",
        close: "Fechar",
        accessDenied: "Acesso Negado",
        noExportPermission: "Você não tem permissão para exportar os dados deste carro.",
        delete: "Excluir",
        downgrade: "Rebaixar",
        downgradeConfirm: "Você tem certeza de que deseja rebaixar para o plano Gratuito?",
        edit: "Editar",
        loading: "Carregando...",
        confirm: "Confirmar",
        processing: "Processando...",
        history: "Histórico",
        currentCar: "Carro Atual",
        purchasedCarTitle: "Compra do Carro",
        initialCost: "Custo Inicial",
        done: "Concluído",
        ok: "OK",
        error: "Erro",
        errorSaving: "Erro ao salvar dados",
        mandatoryFieldsError: "Por favor, preencha todos os campos obrigatórios corretamente.",
        search: "Pesquisar",
        milesShort: "mi",
        kmShort: "km",
        invalidEmail: "Formato de email inválido",
        today: "Hoje",
        car: "Carro",
        all: "Todos",
        deleteConfirm: "Excluir",
        unsavedChangesTitle: "Alterações Não Salvas",
        unsavedChangesMessage: "Você deseja salvar as alterações antes de sair?",
        dontSave: "Não Salvar",
        additionalOptions: "Opções adicionais",
        add: "Adicionar",
        fileTooLarge: "O arquivo é muito grande. O tamanho máximo é {limit} MB.",
        storageFull: "Limite de armazenamento excedido. O armazenamento máximo é {limit} MB.",
        dailyUploadLimit: "Limite diário de upload atingido ({limit} arquivos/dia). Tente novamente amanhã.",
        hourlyUploadLimit: "Limite horário de upload atingido ({limit} arquivos/hora). Tente novamente em uma hora.",
        fileCountLimit: "Máximo de {limit} arquivos permitidos por item.",
        emailParseLimitReached: "Limite de análise de email atingido. Por favor, atualize seu plano ou processe manualmente.",
        emailLimitText: "Limite de processamento de email atingido.",
        monthlyEmailScans: "Escaneamentos Mensais de Email",
        lifetimeEmailScans: "Escaneamentos de Email Vitalícios",
        monthlyFileScans: "Escaneamentos Mensais de Recibos",
        lifetimeFileScans: "Escaneamentos de Recibos Vitalícios",
        fileLimitText: "Limite de escaneamento de recibos atingido.",
        planFreeTier: "Plano Gratuito",
        planProTier: "Plano Pro",
        uploadFailed: "Upload falhou",
        attachments: "Anexos",
        limitsAndUsage: "Limites e Uso",
        addresses: "endereços",
        emailCopied: "Endereço de email copiado!",
        units: {
            liters: "l",
            gallons: "gal",
            kilometers: "km",
            miles: "mi",
        },
        included: "Incluído",
        proOnly: "Apenas PRO",
        month: "mês",
        openInNewTab: "Abrir em nova aba",
        menu: "Menu",
        home: "Início",
        monthsShort: {
            0: "Jan",
            1: "Fev",
            2: "Mar",
            3: "Abr",
            4: "Mai",
            5: "Jun",
            6: "Jul",
            7: "Ago",
            8: "Set",
            9: "Out",
            10: "Nov",
            11: "Dez",
        },
    },
    carMetadata: {
        bodyType: "Tipo de Carroceria",
        drivetrain: "Transmissão",
        transmission: "Transmissão",
        bodyTypes: {
            sedan: "Sedã",
            hatchback: "Hatchback",
            wagon: "Perua",
            suv: "SUV",
            crossover: "Crossover",
            coupe: "Coupé",
            convertible: "Conversível",
            pickup: "Pickup",
            van: "Van / Minivan",
            commercial: "Comercial",
            other: "Outro",
            not_specified: "-",
        },
        drivetrains: {
            not_specified: "-",
            fwd: "Dianteira",
            rwd: "Traseira",
            awd: "AWD / 4x4",
            other: "Outro",
        },
        transmissions: {
            not_specified: "-",
            manual: "Manual",
            automatic: "Automático",
            cvt: "CVT",
            other: "Outro",
        },
        otherLabel: "Outro (especificar)",
        mileageLabel: "Quilometragem",
    },
    auth: {
        welcome: "Bem-vindo",
        welcomeBack: "Bem-vindo de volta",
        signIn: "Entrar",
        signInWithGoogle: "Entrar com o Google",
        signOut: "Sair",
        magicLinkDesc: "Receba um link mágico no seu email",
        magicLinkSent: "Link mágico enviado!",
        magicLinkCheckEmail: "Verifique seu email e clique no link para fazer login.",
        emailAddress: "Endereço de Email",
        getMagicLink: "Obter Link Mágico",
        sending: "Enviando...",
        linkSent: "Link Enviado",
        orContinueWith: "Ou continue com",
        googleAccount: "Conta do Google",
        newUserNote: "Novo aqui? Sua conta será criada automaticamente após seu primeiro login bem-sucedido.",
        magicLinkError: "Falha ao enviar o link mágico. Por favor, verifique seu email e tente novamente.",
        genericError: "Ocorreu um erro. Por favor, tente novamente.",
        projectDescription: "Acompanhe os custos, manutenção e histórico do seu carro em um só lugar.",
        loginError: "Não foi possível entrar",
        loggingIn: "Entrando...",
        authenticating: "Autenticando...",
        authenticatingDesc: "Por favor, aguarde enquanto garantimos sua sessão.",
    },
    settings: {
        title: "Configurações",
        systemPreferences: "Preferências do Sistema",
        appSettings: "Configurações do App",
        dangerZone: "Zona de Perigo",
        theme: "Tema",
        language: "Idioma da Interface",
        currency: "Moeda",
        units: "Unidades",
        distanceUnit: "Unidade de Distância",
        volumeUnit: "Unidade de Volume",
        expenseTypes: "Tipos de Despesa",
        expenseTypesDesc: "Gerenciar categorias",
        categories: "Categorias",
        exportData: "Exportar Dados",
        exportDesc: "Baixar CSV abrangente",
        importData: "Importar Dados",
        importDesc: "Restaurar a partir de backup CSV",
        deleteAccount: "Excluir Conta",
        deleteAccountDesc: "Remover permanentemente todos os dados",
        enableSync: "Ativar Sincronização",
        enableSyncDesc: "Sincronizar dados entre dispositivos",
        account: "Conta",
        accountPlan: "Plano da Conta",
        carsUsage: "Carros",
        carsLimitReached: "Limite de carros atingido",
        storageSize: "Tamanho de Armazenamento",
        emailScans: "Escaneamentos de Email",
        fileScans: "Escaneamentos de Recibos",
        plans: "Planos",
        currentlyPlan: "Atualmente",
        upgradePlan: "Atualizar",
        manageSubscription: "Gerenciar assinatura",
        nextPayment: "Próximo pagamento",
        endsOn: "Termina em",
        adminConsole: "Console do Administrador",
        systemControl: "Controle do Sistema",
        customCategories: "Categorias e Rótulos Personalizados",
        interfaceTheme: "Tema da Interface",
        light: "Claro",
        dark: "Escuro",
        timezone: "Fuso Horário",
        timezoneDesc: "Usado para lembretes de e-mail agendados",
        timeFormat: "Formato de Hora",
        timeFormat24h: "24 horas (14:30)",
        timeFormat12h: "12 horas (2:30 PM)",
        kilometers: "quilômetros (km)",
        miles: "milhas (mi)",
        liters: "litros (l)",
        gallons: "galões (gal)",
        accountManagement: "Gerenciamento de Conta",
        contactUs: "Contate-nos",
        contactDesc: "Para sugestões, pedidos de recursos e perguntas",
        logOut: "Sair",
        logOutConfirmTitle: "Sair",
        logOutConfirmMessage: "Você tem certeza de que deseja sair da sua conta?",
        keepAccount: "Manter Conta",
        deleteAccountConfirmTitle: "Excluir Conta",
        deleteAccountConfirmMessage: "Você tem certeza de que deseja excluir permanentemente sua conta e todos os dados do carro associados? Esta ação não pode ser desfeita.",
        deletePermanently: "Excluir Permanentemente",
        deleting: "Excluindo...",
        contactSupport: "Contate o Suporte",
        messageSent: "Mensagem Enviada!",
        feedbackThanks: "Obrigado pelo seu feedback. Agradecemos sua contribuição e iremos analisá-la.",
        backToSettings: "Voltar para Configurações",
        subjectLabel: "Assunto",
        messageLabel: "Mensagem",
        subjectPlaceholder: "Sobre o que é isso?",
        messagePlaceholder: "Conte-nos sobre sua sugestão, pedido de recurso ou pergunta...",
        enterSubjectAlert: "Por favor, insira um assunto",
        enterMessageAlert: "Por favor, insira uma mensagem",
        sendFailedAlert: "Falha ao enviar a mensagem. Por favor, tente novamente mais tarde.",
    },
    export: {
        title: "Exportar Dados",
        generatePDF: "Gerar PDF",
        carInformation: "Informações do Carro",
        editInfo: "Edite as informações abaixo para personalizar sua exportação",
        editInfoHint: "Você pode remover ou modificar quaisquer campos que não deseja incluir",
        filters: "Filtros",
        expenseTypes: "Tipos de Despesa",
        includeNotes: "Incluir Notas",
        includeImages: "Incluir Arquivos",
        hideDisabled: "Ocultar Itens Desativados",
        itemsCount: "{total} itens, {selected} selecionados",
        selectAll: "Selecionar Todos",
        deselectAll: "Deselecionar Todos",
        expenses: "Despesas",
        notes: "Notas",
        spareParts: "Peças de Reposição",
        images: "Imagens",
        files: "Arquivos",
        summary: "Resumo",
        totalExpenses: "Total de Despesas",
        totalItems: "Total de Itens",
        generatedOn: "Gerado em",
        noItemsSelected: "Nenhum item selecionado para exportação",
        noItemsAvailable: "Nenhum item disponível para exportação",
        generating: "Gerando PDF...",
        downloadPDF: "Baixar PDF",
        pdfFileName: "{carName}_export_{date}.pdf",
        reportTitle: "Relatório de Despesas do Carro",
        exportButton: "Exportar",
        generateCSV: "Gerar CSV",
        formatSelectorTitle: "Selecione o formato",
        formatSelectorMsg: "Por favor, selecione o formato de exportação",
        proFeatureExportTitle: "Recurso Pro: Exportar Dados",
        proFeatureExportDesc: "Atualize para PRO para exportar seu histórico de carro para PDF.",
        exportRestrictedPopup: "A exportação de dados está disponível apenas para usuários Pro.",
        allTypes: "Todos os Tipos",
        statistics: "Estatísticas",
        driven: "Dirigido",
        since: "Desde",
        averageCost: "Custo Médio",
        perKm: "por km",
        perMile: "por milha",
        period: "Período",
        dateFrom: "De",
        dateTo: "Para",
        allTime: "Limpar filtro",
        periodHint: "Se nenhum período for selecionado — todas as despesas são mostradas",
        noExpenses: "Nenhuma despesa corresponde aos filtros",
        expensesSection: "Despesas",
        attachmentsSection: "Anexos",
        imagesCount: "{count} imagens",
        pdfsCount: "{count} PDFs",
        includeParts: "Incluir peças de reposição",
        pageLabel: "Página",
    },
    expenses: {
        title: "Despesas",
        newExpense: "Nova Despesa",
        editExpense: "Editar Despesa",
        openExpense: "Abrir entrada de despesa",
        details: "Detalhes da Despesa",
        selectType: "Selecionar Tipo",
        selectTypePlaceholder: "Selecionar tipo de despesa...",
        shortDescriptionPlaceholder: "Descrição curta...",
        expenseTitle: "Título",
        logEntryTitleLabel: "Título do Registro (Opcional)",
        defaultTitlePlaceholder: "Título padrão - {type}",
        autoTitlePlaceholder: "Será preenchido automaticamente com base nos tipos selecionados",
        carDataTitle: "Dados do Carro",
        defaultTitlePrefix: "O título padrão será -",
        addAnother: "Adicionar outro tipo de despesa",
        addAnotherHint: "Se este registro incluir múltiplos tipos de despesas, você pode adicioná-los todos aqui para garantir estatísticas precisas.",
        carValueDescription: "Valor de mercado estimado do carro neste momento.",
        type: "Tipo",
        date: "Data",
        amount: "Valor",
        totalAmount: "Total",
        splitCosts: "Dividir custos?",
        combineCosts: "Combinar custos",
        amountWork: "Trabalho",
        amountParts: "Peças",
        mileage: "Quilometragem",
        carValue: "Valor do Carro",
        description: "Descrição",
        detailedDescription: "Descrição detalhada",
        electricity: "Eletricidade",
        fuelType: "Tipo de Combustível",
        fuelTypeOptions: {
            petrol: "Gasolina",
            diesel: "Diesel",
            lpg: "LPG",
            electricity: "Eletricidade",
        },
        carData: "Dados do Carro",
        images: "Arquivos",
        addImages: "Adicionar Arquivos",
        addImagesPDFs: "Adicionar Imagens ou PDFs",
        deleteExpense: "Excluir Despesa",
        deleteConfirm: "Você tem certeza de que deseja excluir esta despesa?",
        saveSuccess: "Despesa salva com sucesso",
        thisExpense: "Esta despesa",
        stats: {
            annual: "Anual",
            allTime: "Todos os Tempos",
            avgMonth: "Média/Mês",
            costPer: "Custo/",
            noExpenses: "Nenhuma despesa ainda",
            dragToReorder: "Arraste para reordenar",
        },
        expensesFound: "Criadas",
        noExpensesFound: "Nenhuma despesa encontrada.",
        noDescription: "Sem descrição",
        imagesCount: "Imagens ({count})",
        deleteImageTitle: "Excluir Imagem",
        deleteImageConfirm: "Você tem certeza de que deseja excluir esta imagem? Esta ação não pode ser desfeita.",
        typeLabels: {
            fuel: "Combustível",
            car_wash: "Lavagem",
            repairs: "Reparos",
            maintenance: "Manutenção",
            parts: "Peças de Reposição",
            insurance: "Seguro",
            inspection: "Inspeção",
            tyres: "Pneus",
            parking: "Estacionamento",
            electricity: "Eletricidade",
            taxes: "Impostos",
            other: "Outro",
            info: "Informação",
            service_maintenance: "Manutenção",
            service_repair: "Reparo",
            service_tuning: "Tuning",
        },
        serviceGroup: {
            name: "Serviço",
            selectSubtype: "Selecionar tipo de serviço",
            maintenance: "Manutenção",
            repair: "Reparo",
            tuning: "Tuning",
        },
    },
    repeatingExpenses: {
        title: "Despesa Repetida",
        repeatToggle: "Repetir esta despesa",
        repeatFrequency: "Frequência",
        monthly: "Mensal",
        startDate: "Data de Início",
        nextDate: "A próxima entrada será gerada",
        endDate: "Data de Término",
        noEndDate: "Sem data de término",
        copyOptions: "Opções de Cópia",
        copyTitle: "Copiar título do registro",
        copyLocation: "Copiar localização",
        copyDescription: "Copiar descrição",
        active: "Ativo",
        status: "Status",
        managedByRepeat: "Esta despesa faz parte de uma sequência repetida.",
        placeholder: "Aqui você pode configurar a repetição automática para esta despesa se ocorrer regularmente com o mesmo valor.",
        deleteRepeat: "Excluir Repetição",
        deleteRepeatConfirm: "Você tem certeza de que deseja parar e excluir esta sequência repetida? As futuras entradas não serão geradas. As entradas passadas permanecerão.",
        relatedEntries: "Entradas nesta sequência",
        stopRepeat: "Parar de repetir",
        isRepeating: "Repetindo",
        noTerm: "Indefinidamente",
        until: "A última entrada será gerada",
        summaryCopy: "O sistema irá copiar",
        simulate: "Simular geração da próxima entrada",
        simulateSuccess: "Geração da próxima entrada simulada com sucesso",
        simulateNoDate: "Sem mais datas para gerar (data final alcançada)",
    },
    onboarding: {
        title: "Configurar Perfil",
        welcome: "Bem-vindo!",
        subtitle: "Personalize sua experiência de condução.",
        currency: "Moeda",
        preferredCurrency: "Moeda Preferida",
        distUnit: "Unidade de Distância",
        volUnit: "Unidade de Volume",
        complete: "Concluir Configuração",
    },
    cars: {
        unitChangeWarningTitle: "Aviso de Mudança de Unidade",
        unitChangeWarningMessage: "Alterar essas unidades não converterá seus dados existentes. Todos os registros históricos permanecerão exatamente como foram inseridos.",
        unitChangeWarningConfirm: "Entendido",
        title: "Garagem",
        carAdmins: "Administradores do Carro",
        sharedWithMe: "Compartilhado Comigo",
        manageAdmins: "Gerenciar Administradores",
        adminEmail: "Email do Administrador",
        addAdmin: "Adicionar Administrador",
        addAdminPlaceholder: "ex: amigo@email.com",
        removeAdmin: "Remover",
        removeAdminConfirm: "Você tem certeza de que deseja remover este administrador?",
        adminAdded: "Administrador adicionado",
        adminRemoved: "Administrador removido",
        removeMyAccess: "Remover meu acesso",
        removeMyAccessConfirm: "Você tem certeza de que deseja abrir mão do acesso a este carro?",
        myAccessRemoved: "Acesso removido",
        noAdminsYet: "Nenhum administrador adicionado ainda.",
        adminInfoText: "Administradores podem adicionar e editar despesas, notas e peças de reposição, mas não podem excluir o carro em si.",
        newCar: "Adicionar Carro",
        carNotFound: "Carro Não Encontrado",
        carNotFoundDesc: "O carro solicitado não existe ou você não tem acesso.",
        accessDenied: "Acesso Negado",
        accessDeniedDesc: "Este carro é privado e não está disponível publicamente.",
        backToHome: "Voltar para a Página Inicial",
        adminRestricted: "Acesso Restrito",
        adminRestrictedDesc: "Apenas administradores autorizados podem acessar este console. Por favor, retorne à aplicação principal.",
        returnHome: "Retornar à Página Inicial",
        editCar: "Editar Carro",
        name: "Nome do Carro",
        model: "Modelo",
        year: "Ano",
        plate: "Número da Placa",
        vin: "Número VIN",
        mileage: "Quilometragem Atual",
        initialMileage: "Quilometragem Inicial",
        engineType: "Tipo de Motor",
        tapToChangeIcon: "Toque para mudar o ícone",
        chooseIcon: "Escolher Ícone",
        imageTab: "Imagem",
        iconTab: "Ícone",
        chooseColor: "Escolher Cor",
        chooseEmoji: "Escolher Emoji",
        uploadImage: "Enviar Imagem",
        clickToBrowse: "Clique para navegar pelos arquivos",
        currentCarIcon: "Ícone do carro atual",
        changeImage: "Mudar Imagem",
        zoom: "Zoom",
        rotate: "Rotacionar",
        removeChangeImage: "Remover / Mudar Imagem",
        selectIcon: "Selecionar Ícone",
        cropAndSave: "Recortar & Salvar",
        displayName: "Nome de Exibição",
        displayNamePlaceholder: "ex. Meu Carro de Fim de Semana",
        makeLabel: "Marca *",
        modelLabel: "Modelo *",
        yearLabel: "Ano *",
        fuelTypeLabel: "Tipo *",
        licensePlateLabel: "Placa",
        vinLabel: "VIN",
        notesLabel: "Notas (opcional)",
        notesPlaceholder: "ex. 1.6 TDI, 85kW, 1588cc, bateria 62kWh, AWD, etc.",
        publicAccess: "Tornar carro publicamente acessível",
        publicAccessDesc: "Outros podem visualizar este carro através de um link compartilhado",
        shareLocations: "Permitir visualizar também locais adicionados",
        shareLocationsDesc: "Ative isso para tornar as localizações do carro visíveis na visualização pública",
        deleteCar: "Excluir Carro",
        deleteCarTitle: "Excluir Carro",
        deleteCarConfirm: "Você tem certeza de que deseja excluir '{name}'? Esta ação não pode ser desfeita.",
        noCars: "Nenhum carro na sua garagem",
        addFirstCarNote: "Comece sua jornada adicionando seu primeiro veículo para rastrear despesas.",
        addVehicle: "Adicionar Um Veículo",
        myVehicles: "Meus Veículos",
        favorites: "Favoritos",
        deleteConfirm: "Você tem certeza de que deseja excluir este carro? Todas as despesas associadas serão excluídas.",
        deleteFailed: "Falha ao excluir carro",
        saveFailed: "Falha ao salvar dados do carro",
        adminActions: "Ações de Administrador",
        importCsv: "Importar CSV",
        clearData: "Limpar Dados",
        distanceUnitLabel: "Unidade de Distância",
        volumeUnitLabel: "Unidade de Volume",
        currencyLabel: "Moeda",
        boughtAt: "Data da Compra",
        purchasePrice: "Preço de Compra",
        purchaseMileage: "Quilometragem de Compra",
        createPurchaseRecord: "Criar registro de histórico de compra automaticamente",
        makePlaceholder: "ex. BMW",
        modelPlaceholder: "ex. X5",
        platePlaceholder: "ex. AB-1234",
        vinPlaceholder: "VIN...",
        purchaseInfoNote: "Esta informação criará um registro inicial de 'Informação' em seu histórico com los datos especificados.",
        availableTypes: "Tipos Disponíveis",
        dragToReorder: "Arraste para reorganizar",
        requestTypeNote: "Se você precisar de outro tipo - ",
        requestTypeAction: "nos avise!",
        emailProcessingTitle: "Processamento de Email",
        emailInstructions: "Encaminhe seus recibos para o endereço abaixo. Extrairemos os dados e criaremos despesas automaticamente.",
        recentEmails: "Emails Recebidos",
        viewAllEmails: "VER TODOS ({count})",
        noEmailsReceived: "Nenhum email recebido ainda.",
        analysisResult: "Resultado da Análise",
        vehicleInfo: "Informações do Veículo",
        preferences: "Preferências",
        purchaseHistory: "Histórico de Compras",
        emailProcessing: "Processamento de Email",
        publicAccessTitle: "Acesso Público",
        expenseTypesTitle: "Tipos de Despesas",
        adminActionsTitle: "Ações de Administrador",
        enterPurchaseDateAlert: "Por favor, insira a data da compra",
        allowedSenderEmails: "Emails de Remetente Permitidos",
        allowedEmailsDesc: "Adicione endereços de email que estão autorizados a enviar recibos para este carro. Máximo de 5 endereços.",
        noAllowedEmails: "Nenhum email permitido adicionado.",
        emailAlreadyAdded: "Este email já está permitido para este carro.",
        maxAllowedEmailsReached: "Limite máximo de emails permitidos atingido.",
        addAllowedEmailPlaceholder: "Adicionar email permitido...",
        ownerEmail: "Proprietário",
        onlyOwner: "apenas proprietário",
        defaultAllowed: "Sempre permitido",
        carLimitReachedTitle: "Limite de Carros Atingido",
        carLimitReachedMessage: "Seu plano {plan} permite {limit} carro(s). Você já tem {current}. Vá para as configurações para ver seus limites ou entre em contato conosco para atualizar.",
        carLimitGoToSettings: "Ir para Configurações",
        archivedCars: "Arquivados",
        archiveCar: "Arquivar Carro",
        unarchiveCar: "Desarquivar Carro",
        sellDate: "Data da Venda",
        sellPrice: "Preço de Venda",
        sellMileage: "Quilometragem de Venda",
        archiveConfirm: "Você tem certeza de que deseja arquivar este carro?",
        archiveInstructions: "Arquivar um carro significa que ele não é mais seu ou que você não o mantém mais. Por favor, forneça os detalhes da venda para estatísticas. Isso tornará o carro somente leitura. Os campos abaixo ainda podem ser editados posteriormente.",
        archivedBadge: "Arquivado",
        saleDetails: "Detalhes da Venda",
        saleDetailsNote: "Os detalhes da venda são usados para estatísticas. Você pode atualizá-los se necessário.",
        archiveDetailsNotFillable: "Por favor, preencha todos os campos para arquivar o carro",
        emailAddressWillBeAvailableAfterSave: "O endereço de e-mail estará disponível após salvar o carro.",
        proFeatureAdminTitle: "Recurso Pro: Administradores de Carro",
        proFeatureAdminDesc: "Adicione outros usuários que podem visualizar e gerenciar os dados deste carro.",
        proFeatureEmailTitle: "Recurso Pro: Remetentes Extras",
        proFeatureEmailDesc: "Adicione outros endereços de e-mail permitidos dos quais recibos podem ser enviados para este carro.",
        estimatedMileage: "Quilometragem estimada",
        summaryFrequencyLabel: "Frequência do Resumo",
        summaryFrequencyOptions: {
            none: "Desligado",
            monthly: "Mensal",
            semiAnnually: "Semestralmente",
            annually: "Anualmente",
        },
        healthProfilePrompt: "Complete seu perfil de saúde para uma análise precisa!",
    },
    fuelTypes: {
        not_specified: "-",
        petrol: "Gasolina",
        diesel: "Diesel",
        hybrid: "Híbrido",
        electric: "Elétrico",
        lpg: "LPG",
    },
    statistics: {
        mileageTrend: "Tendência de quilometragem",
        title: "Estatísticas",
        allYears: "Todos os anos",
        totalSpent: "Total Gasto",
        spentIn: "Gasto em {year}",
        perMonth: "por mês",
        overall: "geral",
        vsPrev12m: "vs 12m ant.",
        rolling12m: "Últimos 12m",
        byType: "Por Tipo",
        byMonth: "Por Mês",
        byYear: "Por Ano",
        noData: "Sem dados para este ano",
        mostExpensive: "Mais caro",
        top: "Topo",
        untitled: "Sem Título",
        assetAnalysis: "Análise de Valor e Custo do Ativo",
        burnNote: "* O 'Total Queimado' inclui tanto o dinheiro gasto quanto a estimativa de depreciação do valor do carro.",
        carMarketValue: "Valor de Mercado do Carro",
        cumulativeCosts: "Custos Cumulativos",
        totalBurn: "Total Queimado (Custos + Depreciação)",
        entries: "entradas",
        avgPrice: "Preço Médio",
        consumption: "Consumo",
        price: "Preço",
        fuelPriceTrend: "Tendência de Preço do Combustível",
        spendingTrend: "Tendência de Gastos",
        costPerKmTrend: "Custo por 1 km",
        costPerMileTrend: "Custo por 1 milha",
        serviceTrendsTitle: "Tendências de Serviço",
        expensesOnMap: "Despesas no Mapa",
        visitsCountLabel: "visitas",
        locationsSummary: "Resumo de Locais",
        locationsCountLabel: "lugares",
        noLocationsFoundTitle: "Nenhum local ainda",
        noLocationsFoundDesc: "Adicione locais aos seus registros para vê-los no mapa.",
        addMileageData: "Adicionar quilometragem",
        missingMileageInfo: "Dados insuficientes para calcular o custo por distância. Adicione pelo menos 2 leituras de quilometragem neste período (ou uma antes deste período).",
        mileageModal: {
            title: "Adicionar Quilometragem Faltante",
            description: "Para calcular com precisão os custos por distância para {year}, precisamos saber a quilometragem no início e no final do ano.",
            startOfYear: "Início do ano (1º de Jan)",
            endOfYear: "Fim do ano (31 de Dez)",
            currentMileage: "Quilometragem atual",
            placeholder: "Digite a quilometragem...",
            save: "Salvar Dados",
            foundNearby: "Encontrado nas proximidades ({date}): {value} {unit}",
            useExisting: "Usar este",
        },
        proAnalysis: "Análise Pro",
        detailedAnalysis: "Análise Detalhada",
        upgradeToSee: "Atualize para ver →",
    },
    tabs: {
        dashboard: "Painel",
        expenses: "Despesas",
        stats: "Estatísticas",
        locations: "Locais",
        gallery: "Arquivos",
        parts: "Peças",
        notes: "Notas",
        repair: "Modo de Reparação",
        'repair-switch': "Troca de Carro",
    },
    repairAnalysis: {
        title: "Análise de Decisão de Reparação",
        ownershipLength: "Duração da Propriedade",
        currentValue: "Valor Atual",
        valueOutdated: "O valor pode estar desatualizado",
        addValueToEnable: "Adicione o valor atual do carro para habilitar a análise",
        totalInvested: "Total Investido",
        totalInvestedSub: "Preço de compra + reparos",
        totalExcludesFuel: "exclui combustível / eletricidade",
        fuelLabelFuelOnly: "Total de combustível",
        fuelLabelEnergyOnly: "Total de energia",
        fuelLabelHybrid: "Total de Combustível & Energia",
        fuelTypeFuel: "combustível",
        fuelTypeEnergy: "eletricidade",
        fuelTypeHybrid: "combustível & eletricidade",
        fuelTotalLabel: "Total de Combustível/Energia:",
        projectionMode: "Modo de Projeção",
        projectionModes: {
            lastYear: "Baseado no ano passado",
            average: "Média histórica",
            trend: "Tendência (linear)",
        },
        brakeAssumption: "A manutenção inclui um ciclo estimado de freios de 3 anos",
        repairBuffer: "Inclui buffer de risco de reparo baseado na idade",
        yearLabel: "ano",
        totalInvestedDesc: "Preço de compra + todos os reparos",
        repairToValue: "Reparar para Valor (12m)",
        repairToValueExplain: "Reparos €{cost} vs valor do carro €{value}. Abaixo de 20% é saudável; acima de 50% é alto risco.",
        ownershipPressure: "Pressão de Propriedade",
        ownershipPressureExplain: "Pressão total de custo: reparos €{cost} + perda de valor vs €{value}. Acima de 35% sinaliza estresse financeiro.",
        investmentGap: "Lacuna de Investimento",
        investmentGapExplain: "Total investido €{invested} menos valor atual €{value}. Isso mostra quanto você 'perdeu' na propriedade até agora.",
        investmentGapDesc: "Total investido - valor atual",
        repairExpenses12m: "Custo de Reparação de 12m",
        calculatedYearlyMileage: "Quilometragem anual calculada: {km} km",
        calculatedYearlyRepairs: "Reparos anuais calculados: {amount}",
        set: "Definir",
        plannedRepairCost: "Custo de reparação planejado",
        whatIfTitle: "E se você gastar {amount} agora?",
        updatedScore: "Pontuação atualizada",
        updatedVerdict: "Veredicto atualizado",
        howIsItCalculated: "Como isso é calculado?",
        usedLifespan: "Usado: {usage}% da vida útil esperada",
        remainingLifespan: "Restante: ~{km} km",
        estimatedLifespan: "Vida útil estimada: {km} km",
        lifecycle_stage_early: "Início do ciclo de vida – baixo risco de falhas maiores",
        lifecycle_stage_mid: "Meio do ciclo de vida – desgaste normal",
        lifecycle_stage_late: "Final do ciclo de vida – risco aumentado de reparos",
        lifecycle_stage_end: "Fim da vida útil esperada – alto risco de reparos maiores",
        calculationExplanation: "A análise utiliza o preço de compra do seu veículo, custos recentes de reparo e valor atual estimado para calcular uma pontuação de saúde financeira. Altos custos de reparo em relação ao valor do carro ou depreciação rápida reduzirão a pontuação.",
        confidenceLabel: "Confiança",
        confidenceLevel: {
            high: "Alta",
            medium: "Média",
            low: "Baixa",
        },
        mentalFactorsTitle: "Melhore a precisão com sua experiência",
        mentalFactorsCTA: "Verificação rápida (30 seg)",
        mentalFactorsSurveyTitle: "Sua Experiência",
        mentalFactorsSurveyDesc: "Responda 3 perguntas rápidas para personalizar sua pontuação.",
        q1: "Seu carro atende às suas necessidades?",
        q1Help: "Espaço, conforto, recursos",
        q2: "Você gosta de dirigir seu carro?",
        q2Help: "Visual, conforto, sensação",
        q3: "Você se preocupa com quebras inesperadas?",
        q3Help: "Preocupações com a confiabilidade",
        q4: "Este carro é para família e viagens longas?",
        q4Help: "Prioridade em segurança e confiabilidade",
        factorsTitle: "Fatores de Pontuação",
        factorsDesc: "Veja o que impacta sua pontuação",
        newCarComparison: "Comparação de Carros Novos",
        newCarComparisonDesc: "Compare seu custo mensal atual com a compra de um carro novo.",
        modeLeasing: "Leasing",
        modeFullPrice: "Preço Total",
        downPayment: "Entrada",
        leaseYears: "Prazo (Anos)",
        monthlyPayment: "Pagamento Mensal",
        carPrice: "Preço Total do Carro",
        ownershipYears: "Propriedade Planejada (Anos)",
        insuranceMonthly: "CASCO / Seguro Mensal",
        currentMonthlyCost: "Custo Atual do Automóvel",
        newCarMonthlyCost: "Custo do Carro Novo",
        newCarCheaper: "O carro novo é mais barato em: {amount} / mês",
        newCarMoreExpensive: "O carro novo é mais caro em: {amount} / mês",
        newCarSameCost: "Os custos são exatamente os mesmos.",
        advancedSettings: "Configurações Avançadas",
        yearlyMaint: "Manutenção Anual (€)",
        tyres3Yrs: "Pneus / 3 anos (€)",
        depreciation5Yrs: "Depreciação (5 anos %)",
        newCarYear: "Ano do Carro Novo",
        cumulativeCosts: "Custos Cumulativos (Projeção)",
        comparisonByYear: "Comparação por Ano",
        currentCarLabel: "Carro Atual",
        newCarLabel: "Carro Novo",
        resaleValue: "Valor de Revenda",
        startupCosts: "Custos Iniciais (Carro Usado)",
        inspection: "Inspeção pré-compra",
        initialMaintenance: "Manutenção inicial + óleos",
        registration: "Registro / Taxas",
        total: "Total",
        currentCarTitle: "Carro Atual",
        newCarTitle: "Carro Potencial",
        upfrontInvestment: "Investimento Inicial",
        monthlyReality: "Custo Mensal Real",
        depreciationShort: "Depreciação",
        howCalculated: "Como isso é calculado?",
        deltaMonthly: "Diferença mensal",
        deltaUpfront: "Diferença inicial",
        surveyMeanings: {
            practical: {
                1: "De forma alguma",
                2: "Ajuste ruim",
                3: "Médio",
                4: "Bom ajuste",
                5: "Ajuste perfeito",
            },
            joy: {
                1: "Frustrante",
                2: "Entediante",
                3: "Médio",
                4: "Prazeroso",
                5: "Muito",
            },
            worry: {
                1: "Não preocupado",
                2: "Levemente preocupado",
                3: "Preocupado",
                4: "Muito preocupado",
                5: "Com certeza vou quebrar a qualquer momento",
            },
        },
        verdicts: {
            KEEP: "Financeiramente razoável manter",
            borderline: "Limite – monitorar de perto",
            sell: "Alto risco financeiro – vender pode ser racional",
        },
        factors: {
            trendInc: "Tendência Crescente",
            trendIncDesc: "Os custos de reparo estão aumentando em comparação ao ano passado.",
            lowDepreciation: "Vantagem de Baixa Depreciação",
            lowDepreciationDesc: "Carros mais velhos/baratos perdem menos valor ao longo do tempo.",
            stableRepairs: "Reparos Estáveis",
            stableRepairsDesc: "Seus custos de reparo são estáveis ou estão diminuindo.",
            noHistoricalData: "Sem dados mais antigos que 6 meses.",
            lifecycle_stage: "Estágio do ciclo de vida do veículo",
            high_risk_phase: "Fase de alto risco",
            high_risk_phase_desc: "A combinação de um estágio avançado do ciclo de vida e custos de reparo crescentes indica alto risco.",
            lowCostKm: "Custo Eficiente por KM",
            lowCostKmDesc: "A eficiência geral de operar este carro é excelente.",
            lowFixedCosts: "Baixos Custos Fixos",
            lowFixedCostsDesc: "Seus custos fixos (impostos, seguro) são baixos.",
            usage: "Uso Anual",
            usageDesc: "Distância percorrida nos últimos 12 meses.",
            accidentMinor: "Acidente Menor",
            accidentMinorDesc: "Dano estético ou pequenos reparos.",
            structuralDamage: "Dano Estrutural",
            structuralDamageDesc: "Problemas de estrutura ou quadro reduzem drasticamente o valor.",
            aiLifespanNearEnd: "Fim da Vida Útil Esperada",
            aiLifespanAging: "Componentes Envelhecendo",
            aiLifespanGood: "Vantagem de Baixa Quilometragem",
            aiLifespanDesc: "Baseado na estimativa de vida útil típica da IA para este modelo.",
            aiUpcomingRepairs: "Reparos Futuros (Previsão da IA)",
            aiUpcomingRepairsDesc: "A IA prevê falhas de componentes importantes em breve com base na quilometragem.",
            ownershipFatigue: "Fadiga de Propriedade",
            ownershipFatigueLong: "A propriedade a longo prazo muitas vezes leva à disposição mental para um veículo diferente.",
            ownershipFatigueShort: "O viés inicial de propriedade cria uma tendência mais forte de manter o carro.",
            family_priority: "Família & Viagens Longas",
            replacement_comparison: "Comparação de Substituição",
            none: "Nenhum",
            surface: "Superfície",
            minor: "Menor",
            moderate: "Moderado",
            severe: "Severo",
            structural: "Estrutural",
            major: "Maior",
            critical: "Crítico",
            full: "Completo",
            improveLabel: "O que melhoraria isso:",
            info_original_price: "O preço aproximado deste carro quando era novo. Ajuda a estimar a estabilidade do valor. Carros mais antigos com valor restante mais baixo são financeiramente mais seguros.",
            info_current_value: "Quanto você poderia vendê-lo hoje. Usado para verificar se os reparos são uma grande porcentagem do valor do carro, o que sinaliza um mau investimento.",
            info_yearly_mileage: "Maior quilometragem aumenta o desgaste. Baixa quilometragem pode estender significativamente a vida do carro.",
            info_estimated_repairs: "Custo contínuo para manter o carro funcionando. Altos custos anuais reduzem a atratividade de manter o carro.",
            info_planned_repairs: "Reparos conhecidos que estão por vir. Simula pressão imediata sobre sua decisão.",
            info_ownership_years: "Há quanto tempo você possui este carro? Isso afeta a fadiga psicológica de propriedade e o viés do comprador inicial.",
            info_rust: "Risco crítico a longo prazo. Ferrugem estrutural reduz a segurança. Ferrugem severa torna a venda uma opção melhor.",
            info_crashes: "Acidentes estruturais afetam a segurança e a confiabilidade. Eles também reduzem significativamente o valor de revenda.",
            info_repaint: "Indica danos passados ou consertos estéticos. Pequeno impacto, a menos que problemas mais profundos tenham sido ocultados.",
            info_unresolved: "Custos futuros ocultos. Falhas conhecidas na eletrônica, motor ou manutenção que precisam de atenção.",
            info_fit: "O carro atende às suas necessidades (espaço, conforto)? Um ajuste ruim significa que você está mais propenso a substituí-lo.",
            info_joy: "O valor emocional importa. Sem alegria significa que você está mentalmente pronto para um carro novo.",
            info_worry: "Estresse percebido de confiabilidade. Alta preocupação é um forte sinal para substituir o carro.",
        },
        explanations: {
            repairFreq: "Seu carro teve {visits} visitas de serviço nos últimos 12 meses. Visitas frequentes indicam menor confiabilidade e maior incômodo.",
            repairVsValue: "Nos últimos 12 meses, seus reparos custaram €{cost}, enquanto o valor estimado do carro é €{value}. Isso representa {ratio}% do valor total do carro.",
            stableRepairsDetailYearly: "No ano passado, você gastou €{cost1} em reparos, mas no ano anterior €{cost2}. Mudança de {percent}% ({trend}).",
            stableRepairsDetailHalfYearly: "Nos últimos 6 meses, você gastou €{cost1}, nos 6 meses anteriores €{cost2}. Mudança de {percent}% ({trend}).",
            mileage: "Com {mileage} km, o carro entra em uma zona de maior risco para falhas de peças importantes (transmissão, componentes do motor).",
            planned: "Você tem €{cost} em reparos planejados, o que reduz imediatamente a segurança financeira de manter o carro.",
            lowDep: "Carros avaliados em torno de €{value} perdem muito pouco valor por ano, compensando custos de reparo mais altos.",
            depRisk: "Seu carro tem {age} anos e completou principalmente seu ciclo de depreciação, o que significa que você não perde dinheiro com a queda de seu valor.",
            stable: "Você gastou €{costThisYear} este ano em comparação com €{costLastYear} no ano passado, o que representa uma diminuição de {percent}%. Custos previsíveis são matematicamente favoráveis.",
            costKm: "Você dirigiu {km} km no ano passado. Os custos operacionais foram de €{costKm} por quilômetro, o que mostra excelente eficiência econômica.",
            fixedCosts: "Você pagou €{costs} em custos fixos anuais (seguro/imposto). Essa baixa carga oferece uma tranquilidade extra.",
            usage: "Você dirige cerca de {km} km por ano com base em seus registros.",
            practical_fit: "Você avaliou o ajuste prático em {score}/5, ajustando a pontuação matemática em {impact} pontos.",
            emotional_satisfaction: "Você avaliou sua satisfação emocional em {score}/5, ajustando a pontuação em {impact} pontos.",
            reliability_anxiety: "Sua confiança na confiabilidade é {score}/5, impactando a pontuação em {impact} pontos.",
            rust: "Ferrovia estrutural ou sob o carro severamente enferrujada geralmente significa riscos de segurança ou cenários de perda total.",
            accident: "Danos anteriores, dependendo da gravidade, reduzem inerentemente o valor de revenda e a segurança do veículo.",
            structural: "Problemas estruturais tornam o carro automaticamente financeiramente perigoso.",
            ai_lifespan: "Com {current} km, o carro completou {ratio}% da sua vida útil estimada pela IA ({expect} km).",
            ai_repairs: "Os dados da IA indicam que {count} grandes reparos típicos específicos do modelo tendem a ocorrer nesta quilometragem.",
            lifecycle_stage: "O que significa vida útil? {total} km – este é o ponto previsto pela IA quando grandes reparos estruturais (motor, câmbio, etc.) normalmente começam para este modelo. Não é o fim da vida do carro – o carro ainda pode dirigir, mas com custos de manutenção significativamente mais altos. A vida física total de um carro típico é de 500k–1M km, mas torna-se economicamente inviável muito antes.",
        },
        ratios: {
            healthy: "Saudável",
            monitor: "Monitorar",
            highRisk: "Alto risco",
            stable: "Estável",
            warning: "Aviso",
            financialStress: "Estresse financeiro",
        },
        proFeatureTitle: "Recurso Pro: Modo de Reparação",
        proFeatureDesc: "Desbloqueie o motor de decisão para obter uma análise financeira profissional das reparações do seu veículo. Usuários gratuitos veem uma demonstração com dados de exemplo.",
        viewDemo: "Ver Demonstração Ao Vivo",
        upgradeToUnlock: "Atualize para PRO para analisar seu carro",
    },
    carTasks: {
        title: "Tarefas do Carro",
        placeholderTitle: "Rastreamento de Manutenção",
        placeholderDesc: "Cronograma de manutenção para o modelo do seu carro.",
        demoTitle: "Tarefas de Manutenção do Carro",
        demoSubtitle: "Rastreamento inteligente para o seu veículo",
        feature1Title: "Geração Automática de Tarefas",
        feature1Desc: "Gera automaticamente tarefas como trocas de óleo, substituições de filtro e verificações de correia dentada com base no modelo do seu carro.",
        feature2Title: "Integração de Despesas",
        feature2Desc: "Analisa seu histórico de serviços para entender o que já foi feito e quando.",
        feature3Title: "Lembretes Inteligentes",
        feature3Desc: "Receba notificações com base no tempo e na quilometragem. O rastreamento é redefinido automaticamente quando você marca uma tarefa como concluída.",
        getStarted: "Começar",
        fakeDoorPopupTitle: "Feedback Bem-vindo",
        fakeDoorPopupMessage: "Estamos desenvolvendo tarefas de manutenção de carros. Este recurso permitirá que você rastreie intervalos de serviço automaticamente. Quais tarefas ou recursos específicos você gostaria de ver mais?",
        fakeDoorPopupPlaceholder: "Seus pensamentos...",
        noTasksYet: "Nenhuma tarefa ainda",
        deleteAllTitle: "Limpar lista de tarefas?",
        deleteAllMessage: "Você tem certeza de que deseja excluir todas as {count} tarefas para este carro? Esta ação não pode ser desfeita.",
        deleteAllSuccess: "Todas as tarefas foram excluídas com sucesso.",
        sortPriority: "Prioridade",
        sortType: "Tipo",
        sortDate: "Mais recente",
        status: {
            overdue: "ATRASADO",
            pending: "PENDENTE",
            noData: "SEM DADOS",
            upcoming: "Próximo",
            nextIn: "Próximo em {dist} {unit}",
            overdueBy: "{dist} {unit} atrasado",
            afterDays: "Em {days} dias",
            overdueDays: "{days} dias atrasado",
        },
        form: {
            newTitle: "Nova Tarefa",
            actionType: "Inspecionar ou Substituir?",
            intervalMonths: "Intervalo (Meses)",
            intervalDistance: "Intervalo (Distância)",
            diffFirstInterval: "O primeiro intervalo difere do intervalo base",
            firstInterval: "Primeiro Intervalo",
            historyToggle: "Esta tarefa já foi realizada para este carro?",
            historyToggleDesc: "Se NÃO, assumimos que nunca foi feita desde a produção.",
            lastPerformedOptional: "Quando foi a última vez que foi realizada? (Opcional)",
            deleteTitle: "Excluir Tarefa",
            deleteConfirm: "Você tem certeza de que deseja excluir esta tarefa?",
            saveError: "Falha ao salvar a tarefa",
            historyConfirmed: "Histórico Confirmado",
            reminders: "Lembretes",
            notifyMileage: "Notifique-me quando a quilometragem estimada for atingida",
            notifyDate: "Notifique-me quando a data for atingida",
            nextMileageReminder: "Data estimada",
            nextDateReminder: "Data de vencimento",
            estimatedDate: "Data estimada",
            missingLastMileage: "Faltando a última quilometragem realizada",
            missingLastDate: "Faltando a última data realizada",
            missingStartDate: "Não foi possível determinar a data de início",
            additionalOptions: "Opções Adicionais",
            reminderInfoMissing: "Estado informativo: lembretes estão desativados até que os dados da última execução sejam fornecidos.",
        },
    },
    dashboard: {
        title: "Painel",
        quickActions: "Ações Rápidas",
        addExpense: "Adicionar Despesa",
        editCar: "Editar Carro",
        recentExpenses: "Despesas",
        seeAll: "Ver Todas",
        recentGallery: "Arquivos",
        thisMonth: "Este Mês",
        totalSpent: "Total Gasto",
        avgPerMonth: "Média/Mês",
        recentNotes: "Notas",
        recentParts: "Peças",
        noRecentExpenses: "Sem despesas recentes",
        noRecentGallery: "Sem fotos recentes",
        noRecentNotes: "Sem notas recentes",
        noRecentParts: "Sem peças recentes",
        createNote: "Criar Novo",
        createPart: "Criar Novo",
        createExpense: "Criar Novo",
        noFiles: "Nenhum arquivo adicionado ainda",
        needSomethingMore: "Precisa de algo mais?",
        letUsKnow: "nos avise!",
    },
    expenseTypes: {
        editTitle: "Editar Tipo de Despesa",
        newTitle: "Novo Tipo de Despesa",
        categoryName: "Nome da Categoria",
        placeholderName: "ex. Serviço",
        signatureColor: "Cor da Assinatura",
        icon: "Ícone da Categoria",
        deleteConfirm: "Você tem certeza de que deseja excluir o tipo '{name}'?",
    },
    spareParts: {
        title: "Peças de Reposição",
        connectedWithRecords: "Conectado com Registros",
        toBuy: "Para Comprar",
        usedInExpenses: "Usado em Despesas",
        noPartsToBuy: "Nenhuma peça adicionada à lista de compras",
        noPartsUsed: "Nenhuma peça vinculada a despesas ainda",
        quantity: "Qtd",
        partCode: "Código da Peça",
        price: "Preço",
        link: "Link",
        comment: "Comentário",
        addPart: "Adicionar Peça de Reposição",
        editPart: "Editar Peça de Reposição",
        openPart: "Abrir entrada da Peça",
        nameLabel: "Nome",
        manufacturerLabel: "Fabricante",
        priceLabel: "Preço ({currency})",
        imagesLabel: "Arquivos",
        linkedHistory: "Histórico Vinculado",
        partManagedNote: "Esta peça é gerenciada através de uma despesa",
        cannotDeleteNote: "Como esta peça está vinculada a uma despesa, não pode ser excluída separadamente. Exclua ou edite a despesa para gerenciar o ciclo de vida desta peça.",
        partNamePlaceholder: "Nome da peça...",
        manufacturerPlaceholder: "Bosch, Brembo, etc.",
        additionalInfoPlaceholder: "Informações adicionais...",
        namePlaceholder: "ex. Pastilhas de Freio",
        codePlaceholder: "ex. 5Q0 698 151",
        linkPlaceholder: "https://...",
        vinPlaceholder: "WBADT...",
        savePart: "Salvar Peça",
        deletePart: "Excluir peça de reposição",
        deleteConfirm: "Você tem certeza de que deseja excluir esta peça de reposição?",
        sparePartsLabel: "Peças de Reposição",
        partNumber: "Peça #{number}",
        imagesLimitLabel: "Arquivos (até 5)",
        optional: "(opcional)",
        selectPart: "Selecionar Peça de Reposição",
        createNew: "Criar nova peça de reposição",
        searchPlaceholder: "Pesquisar por nome ou código...",
        noResults: "Nenhuma peça encontrada",
        noPartsYet: "Nenhuma peça ainda. Crie a sua primeira!",
        selectorDescription: "Encontre e selecione uma peça de reposição existente ou crie uma nova",
        alreadyAdded: "Esta peça já foi adicionada",
        statistics: {
            avgPrice: "Média",
            lastPrice: "Último",
            usedTimes: "Usado {count} vezes",
            totalPurchased: "Total: {quantity}x",
        },
        usage: {
            title: "Esta Compra",
            quantity: "Quantidade",
            pricePerUnit: "Preço por unidade",
            comment: "Comentário",
            commentPlaceholder: "ex., Comprado na AutoZone",
            total: "Total",
            transactionData: "Esta Transação",
        },
        masterData: "Informações da Peça Principal",
        masterRecord: {
            title: "Detalhes da Peça (compartilhado)",
            editMaster: "Editar Registro Principal",
            warning: "Mudanças no registro principal afetam todos os usos",
        },
    },
    reminders: {
        title: "Lembretes",
        reminder: "Lembrete",
        noteReminder: "Lembrete de Nota",
        partReminder: "Lembrete de Peça",
        today: "Hoje",
        tomorrow: "Amanhã",
        yesterday: "Ontem",
        inXDays: "em {x} dias",
        xDaysAgo: "há {x} dias",
        inXMonths: "em {x} meses",
        xMonthsAgo: "há {x} meses",
        active: "Ativo",
        activeDesc: "Se necessário, você pode desativar este lembrete sem excluí-lo",
        disabled: "Desativado",
        yearly: "Anual",
        markSeen: "Reconhecer",
        addReminder: "Novo Lembrete",
        editReminder: "Editar Lembrete",
        extraReminders: "Lembretes Extras",
        extraRemindersDesc: "Envie 3 lembretes adicionais nos dias seguintes (4 no total) se não forem interrompidos.",
        remindDate: "Data",
        remindTime: "Hora",
        repeatYearly: "Repetir Anualmente",
        repeatYearlyDesc: "Este lembrete ocorrerá automaticamente todos os anos na mesma data/mês/dia/hora até ser desativado",
        standalone: "Lembretes Independentes",
        embedded: "Lembretes Vinculados",
        noReminders: "Sem lembretes ativos",
        deleteReminder: "Excluir Lembrete",
        nameLabel: "Nome",
        descriptionLabel: "Descrição",
        namePlaceholder: "Nome do lembrete",
        descriptionPlaceholder: "Descrição ou nota curta",
        simulateReminder: "Simular momento do lembrete",
        simulateSuccess: "E-mail de simulação enviado",
        timezone: "Fuso Horário",
        nextReminder: "Próximo lembrete",
        futureTimeError: "O horário do lembrete deve ser no futuro",
    },
    notes: {
        title: "Notas",
        emptyNote: "Nota vazia",
        noNotes: "Sem notas ainda",
        addNote: "Adicionar Nota",
        editNote: "Editar Nota",
        viewNote: "Ver Nota",
        openNote: "Abrir entrada da Nota",
        titleLabel: "Título",
        contentLabel: "Conteúdo",
        noteTitlePlaceholder: "Título da nota...",
        noteContentPlaceholder: "Escreva sua nota aqui...",
        saveNote: "Salvar Nota",
        deleteNote: "Excluir Nota",
        publicNote: "Tornar nota pública",
        publicNoteDesc: "Outros podem visualizar esta nota através do link compartilhado",
        deleteConfirm: "Você tem certeza de que deseja excluir esta nota?",
        enterTitleAlert: "Por favor, insira um título",
        saveFailed: "Falha ao salvar a nota",
        thisNote: "Esta nota",
        deleteFailed: "Falha ao excluir a nota",
        pinToTop: "Fixar no topo",
    },
    locations: {
        title: "Locais",
        singleTitle: "Local",
        newLocation: "Novo Local",
        emptyLocation: "Local vazio",
        noLocations: "Para estatísticas - você pode adicionar o local onde esta despesa de carro ocorreu",
        addLocation: "Adicionar Local",
        editLocation: "Editar Local",
        viewLocation: "Ver Local",
        openLocation: "Abrir Local",
        createNew: "Criar novo local",
        selectLocation: "Selecionar local",
        searchLocations: "Pesquisar locais...",
        nameLabel: "Nome",
        addressLabel: "Endereço ou Coordenadas",
        descriptionLabel: "Comentário/Descrição",
        namePlaceholder: "ex.: Serviço do Centro",
        mapLabel: "Localização",
        searchPlaceholder: "Pesquisar endereço...",
        addressPlaceholder: "Insira o endereço e selecione...",
        descriptionPlaceholder: "Informações adicionais...",
        fillAddress: "Preencher endereço do mapa",
        saveLocation: "Salvar Local",
        deleteLocation: "Excluir local",
        deleteConfirm: "Você tem certeza de que deseja excluir este local?",
        enterNameAlert: "Por favor, insira um nome",
        saveFailed: "Falha ao salvar o local",
        thisLocation: "Este local",
        deleteFailed: "Falha ao excluir o local",
        myLocations: "Meus Locais",
        usedInEntries: "Usado em entradas",
        noEntries: "Local não está em uso",
        noEntriesThisCar: "Este local não foi utilizado para este carro",
        removeLocation: "Remover local",
        noResults: "Nenhum resultado encontrado",
    },
    gallery: {
        title: "Arquivos",
        noImages: "Nenhuma imagem adicionada",
        addImagesNote: "Adicione imagens ao carro ou despesas",
        totalImages: "Total de {count} imagens",
        imageAlt: "Imagem {number}",
        commentPlaceholder: "Comentário do arquivo",
        isReceipt: "Este arquivo é um recibo",
        deleteImageTitle: "Excluir arquivo",
        deleteImageConfirm: "Você tem certeza de que deseja excluir permanentemente este arquivo?",
    },
    search: {
        placeholder: "Pesquisar despesas, peças, notas...",
        typeToSearch: "Digite para começar a pesquisar",
        noResults: "Nenhum resultado encontrado para '{query}'",
        carImage: "Imagem do Carro",
        expenseImage: "Imagem da Despesa",
        noteImage: "Imagem da Nota",
        galleryImage: "Imagem da Galeria",
        untitledExpense: "Despesa Sem Título",
    },
    landing: {
        nav: {
            features: "Funcionalidades",
            howItWorks: "Como funciona",
            pricing: "Preços",
            login: "Entrar",
            getStarted: "Começar",
            garage: "Garagem",
        },
        hero: {
            title: "Saiba Exatamente Quanto Seu Carro",
            subtitle: "Realmente Custa",
            description: "Acompanhe despesas, registre reparos e veja para onde seu dinheiro realmente vai.",
            subheadline: "O painel profissional orientado por dados para proprietários de carros meticulosos.",
            startTracking: "Começar",
            viewDemo: "Demo do Carro ->",
            trustSignal: "Junte-se a mais de 1.200 proprietários meticulosos que já mapearam mais de 5 milhões de quilômetros de custos reais de carro.",
            ctaNote: "Sem cartão de crédito. Sem vendas insistentes. Apenas clareza.",
            benefits: {
                repairVsSell: {
                    title: `Reparar vs. Vender`,
                    description: `Identifique o limite de "Reparar vs. Vender" — Pare de se perguntar se você está despejando dinheiro em um poço sem fundo. Saiba o momento exato em que uma reparação não é mais um investimento inteligente.`
                },
                costPerKm: {
                    title: `Custo por KM`,
                    description: `Acompanhe seu custo real por quilômetro — Vá além do painel. Veja a imagem financeira completa dos seus hábitos de direção que outros aplicativos deixam de fora.`
                },
                automation: {
                    title: `Automação`,
                    description: `Automatize seu registro — Basta encaminhar suas faturas ou simplesmente enviar seus comentários por e-mail. Nossa IA organiza a história técnica do seu carro para você.`
                }
            },
        },
        features: {
            title: "Tudo que você precisa para gerenciar seu carro",
            subtitle: "Pare de usar planilhas e pastas bagunçadas. My Car Costs traz ferramentas profissionais de gerenciamento de frotas para sua garagem pessoal.",
            expenseTracking: {
                title: "Rastreamento de Despesas",
                description: "Registre combustível, serviços, seguros e reparos. Categorize custos e visualize tendências de gastos ao longo do tempo.",
            },
            spareParts: {
                title: "Gerenciador de Peças Sobressalentes",
                description: "Mantenha um inventário detalhado de peças sobressalentes, números de peças e notas de compatibilidade para todos os seus reparos.",
            },
            serviceHistory: {
                title: "Histórico de Serviços & Notas",
                description: "Mantenha um livro de serviços digital. Adicione notas detalhadas sobre manutenção, modificações ou planos futuros.",
            },
            documentStorage: {
                title: "Armazenamento de Documentos",
                description: "Envie recibos, faturas e fotos do seu carro. Mantenha toda a sua documentação segura e acessível.",
            },
            emailForwarding: {
                title: "Encaminhamento de E-mail",
                description: "Encaminhe faturas diretamente para sua caixa de entrada única. Nós extrairemos os dados e os adicionaremos ao seu painel automaticamente.",
            },
            multiCar: {
                title: "Garagem Multi-Carro",
                description: "Gerencie um carro ou toda uma frota. Troque entre veículos instantaneamente e veja estatísticas agregadas.",
            },
            repeatingExpenses: {
                title: "Despesas Repetidas",
                description: "Automatize o rastreamento de custos mensais regulares, como seguro, estacionamento ou leasing.",
            },
            smartReminders: {
                title: "Lembretes Inteligentes",
                description: "Defina alertas personalizados para peças de reposição e notas de serviço para nunca perder uma tarefa de manutenção.",
            },
        },
        howItWorks: {
            title: "Fluxo de Trabalho Simples e Poderoso",
            step1: {
                title: "Adicione seu veículo",
                description: "Insira os detalhes do seu carro para criar sua garagem digital.",
            },
            step2: {
                title: "Registre despesas e arquivos",
                description: "Tire uma foto de um recibo ou encaminhe um e-mail. Nós cuidamos do resto.",
            },
            step3: {
                title: "Obtenha insights",
                description: "Veja seu custo por quilômetro, gastos mensais e cronograma de manutenção.",
            },
        },
        useCases: {
            title: "Perfeito para",
            enthusiasts: {
                title: "Entusiastas de Carros",
                description: "Rastreie cada modificação, número de peça e intervalo de manutenção para seu carro de projeto.",
            },
            dailyDrivers: {
                title: "Motoristas Diários",
                description: "Saiba exatamente quanto custa seu trajeto e nunca perca uma data de serviço.",
            },
            flippers: {
                title: "O Flipper Inteligente",
                description: "Construa um volume verificável de dados que prove o verdadeiro valor do seu carro para os compradores.",
            },
            fleets: {
                title: "Pequenas Frotas",
                description: "Gerencie vários veículos da empresa em um só lugar, sem a sobrecarga de software empresarial.",
            },
        },
        foundersNote: {
            title: "Nota do Fundador",
            content: "Estou construindo o MyCarCosts para ser a ferramenta definitiva para pessoas que realmente se importam com seus carros. Há algum recurso faltando no seu fluxo de trabalho? Entre em contato comigo diretamente. Se fizer sentido para a comunidade, nós o construiremos juntos.",
        },
        pricing: {
            freeLimitedTime: "Gratuito por tempo limitado",
            title: "Preços Simples e Transparentes",
            subtitle: "Comece grátis, faça upgrade conforme cresce.",
            perMonth: "mês",
            monthly: "Mensal",
            yearly: "Anual",
            save25: "Economize 25%",
            billedAnnually: "Cobrado anualmente ({amount})",
            free: {
                title: "Grátis",
                cta: "Começar",
            },
            pro: {
                title: "Pro",
                cta: "Upgrade para Pro",
                recommended: "Recomendado",
                earlyAdopter: "Preço para primeiros adotantes",
                priceLock: "Garanta este preço agora. O preço pode aumentar no futuro.",
            },
            custom: {
                title: "Custom",
                cta: "Entre em Contato",
            },
            features: {
                oneCar: "1 carro",
                unlimitedExpenses: "Despesas ilimitadas",
                unlimitedSpareParts: "Peças de reposição ilimitadas",
                unlimitedNotes: "Notas ilimitadas",
                repeatedExpenses: "Despesas repetidas",
                emailReminders: "Notas e lembretes de peças de reposição por e-mail",
                basicStatistics: "Estatísticas básicas",
                fullStatistics: "Estatísticas completas",
                storage50mb: "50 Mb de armazenamento de arquivos",
                unlimitedArchivedCars: "Carros arquivados ilimitados",
                dataExport: "Exportação de dados",
                allInFreePlus: "tudo no gratuito plus:",
                threeCars: "Até 3 carros",
                storage2gb: "2 Gb de armazenamento de arquivos",
                emailParsing: "Análise de e-mail",
                carAdmins: "Administradores de carro",
                moreCars: "Mais carros",
                moreFileStorage: "Mais armazenamento de arquivos",
                customRequirements: "Requisitos personalizados",
            },
            upgradePopup: {
                title: "Em Breve!",
                message: "As versões pro e personalizadas ainda não foram lançadas, mas serão em breve. Para nos ajudar a lançar mais rápido - por favor, escreva qual recurso específico você espera da versão pro / personalizada, ou qualquer outra coisa que você gostaria que melhorássemos para tornar esta plataforma ainda melhor para você!",
                placeholder: "Escreva seu feedback aqui...",
                submit: "Enviar",
                cancel: "Cancelar",
                thanksTitle: "Obrigado!",
                thanksMessage: "Recebemos seu feedback e trabalharemos para tornar o MyCarCosts ainda melhor!",
                thanksOk: "Ok",
            },
        },
        migration: {
            title: "Mudando do Excel ou de outro aplicativo?",
            subtitle: "Oferecemos um serviço profissional de migração de dados para que você comece a usar instantaneamente.",
            pricingModel: "Modelo de preços",
            small: {
                title: "Conjunto de dados pequeno",
                description: "< 500 linhas",
                price: "R$19–29",
            },
            medium: {
                title: "Conjunto de dados médio",
                description: "500–5.000 linhas",
                price: "R$49",
            },
            large: {
                title: "Grande / Bagunçado",
                description: "Sistemas legados ou arquivos complexos",
                price: "Orçamento personalizado",
            },
            process: {
                title: "Como funciona",
                step1: "Você envia seu arquivo",
                step2: "Nós avaliamos os dados",
                step3: "Pagamento único",
                step4: "Nós cuidamos da importação",
            },
            cta: "Solicitar Migração",
        },
        repairAnalysisSection: {
            title: "Reparar ou Vender? Deixe os dados decidirem.",
            subtitle: "Análise financeira profissional para seu veículo. Pare de adivinhar e comece a saber se essas reparações realmente valem a pena.",
            features: {
                personalized: {
                    title: "Análise Personalizada",
                    description: "Para os seus carros rastreados, usamos despesas e parâmetros históricos reais, adicionando custos planejados para gerar uma avaliação.",
                },
                public: {
                    title: "Simulador Público",
                    description: "Avaliando uma compra potencial? Use nossa ferramenta pública em /repair para gerar uma análise detalhada inserindo apenas alguns detalhes chave.",
                },
                whatIf: {
                    title: "Simulador de E Se",
                    description: "Insira um custo de reparo planejado e veja instantaneamente como isso afeta a pontuação financeira do seu carro.",
                },
            },
            cta: "Ver Análise de Exemplo",
        },
        faq: {
            title: "Perguntas Frequentes",
            subtitle: "Tudo o que você precisa saber sobre My Car Costs",
            questions: {
                mobileApps: {
                    question: "Haverá aplicativos para iOS e Android?",
                    answer: "Sim! Aplicativos móveis para iOS e Android estão chegando em breve. Estamos trabalhando duro para trazer a melhor experiência móvel.",
                },
                dataPrivacy: {
                    question: "Meus dados são privados e seguros?",
                    answer: "Absolutamente. Seus dados são criptografados e armazenados com segurança. Apenas você pode acessar as informações do seu carro, a menos que você escolha explicitamente torná-las públicas.",
                },
                freePlan: {
                    question: "O plano gratuito é realmente gratuito para sempre?",
                    answer: "Sim! O plano gratuito sempre estará disponível com um carro e todos os recursos essenciais. Você pode fazer upgrade para Pro a qualquer momento para até 3 carros e recursos avançados.",
                },
                dataExport: {
                    question: "Posso exportar meus dados?",
                    answer: "Sim, você pode exportar todos os seus dados a qualquer momento em formato CSV ou PDF. Seus dados são seus, e você nunca fica preso.",
                },
                emailImport: {
                    question: "Como funciona a importação de e-mail?",
                    answer: "Cada carro recebe um endereço de e-mail exclusivo. Basta encaminhar suas faturas e nós extrairemos os dados automaticamente.",
                },
                multipleUsers: {
                    question: "Várias pessoas podem acessar o mesmo carro?",
                    answer: "Atualmente, cada carro pertence a uma conta. No entanto, você pode tornar um carro visível publicamente para compartilhar acesso somente leitura com outros.",
                },
            },
        },
        cta: {
            title: "Pare de adivinhar. Comece a saber.",
            subtitle: "Transforme o histórico do seu carro em decisões financeiras claras. Junte-se a milhares de proprietários inteligentes que sabem exatamente quando investir ou vender.",
            button: "Começar agora",
            note: "Sem cartão de crédito. Sem vendas insistentes. Apenas clareza.",
        },
        footer: {
            product: "Produto",
            legal: "Jurídico",
            changelog: "Registo de Alterações",
            privacy: "Política de Privacidade",
            contact: "Contacto",
            contactEmail: "info@mycarcosts.com",
            questions: "Alguma dúvida? Entre em contato conosco em:",
        },
        privacy: {
            title: "Política de Privacidade",
            lastUpdated: "Última atualização: 25 de março de 2026",
            introduction: "No My Car Costs, levamos a sua privacidade a sério. Esta política explica como lidamos com os seus dados.",
            dataCollection: {
                title: "Coleta de Dados",
                description: "Coletamos apenas o mínimo absoluto de informações necessárias para fornecer nosso serviço.",
                email: "Identidade da Conta: Usamos seu endereço de e-mail como seu identificador único e para autenticação (por exemplo, links mágicos ou login do Google).",
                documents: "Armazenamento de Documentos: Os arquivos que você envia são armazenados com segurança em armazenamento em nuvem criptografado.",
            },
            carData: {
                title: "Seu Controle de Dados",
                description: "As informações que você insere (despesas, quilometragem, peças) são armazenadas para seu uso pessoal e análises.",
                noValidation: "Não validamos os dados do carro que você fornece; é sua responsabilidade garantir a precisão.",
                privateByDefault: "Por padrão, seus dados são privados. Identificadores técnicos para arquivos são não sequenciais e não indexados por motores de busca.",
                rightToForgotten: "Direito ao Esquecimento: Você pode excluir sua conta a qualquer momento, o que remove imediata e permanentemente todos os seus registros e arquivos.",
            },
            thirdParty: {
                title: "Serviços de Terceiros",
                description: "Não vendemos os seus dados pessoais. Ao utilizar o Login da Google, apenas acedemos ao seu endereço de e-mail para fins de identificação.",
            },
            emailIngestion: {
                title: "Recolha de E-mail",
                description: "Os e-mails enviados para o nosso serviço de recolha são armazenados para fornecer um histórico de processamento. Pode eliminar manualmente e-mails individuais ou todo o seu histórico a qualquer momento.",
            },
        },
        emails: {
            deleteAll: "Eliminar Tudo",
            deleteAllConfirm: "Tem a certeza de que deseja eliminar todo o histórico de e-mails para este carro? Esta ação é irreversível.",
            deleteConfirm: "Tem a certeza de que deseja eliminar este e-mail?",
            noEmails: "Nenhum e-mail recebido ainda.",
        },
        terms: {
            title: "Termos e Condições",
            lastUpdated: "Última atualização: 25 de março de 2026",
            introduction: "Ao aceder ou utilizar o MyCarCosts, concorda em ficar vinculado por estes Termos e Condições. Se não concordar, por favor não utilize o nosso serviço.",
            acceptance: {
                title: "1. Aceitação dos Termos",
                description: "Estes termos constituem um acordo legalmente vinculativo entre si e o MyCarCosts relativamente à sua utilização da nossa aplicação e serviços.",
            },
            service: {
                title: "2. Descrição do Serviço",
                description: "O MyCarCosts fornece uma plataforma para acompanhamento de despesas de veículos, gestão de manutenção e análise financeira. Isto inclui análise de recibos potenciada por IA e ferramentas de visualização de dados.",
            },
            responsibilities: {
                title: "3. Responsabilidades do Utilizador",
                description: "É responsável pela precisão de todos os dados que introduz, incluindo quilometragem, números VIN e custos. Deve manter as suas credenciais de login (e-mail/magic link) seguras e não as partilhar com terceiros não autorizados.",
            },
            plans: {
                title: "4. Planos de Serviço e Limites",
                description: "Oferecemos planos Gratuito e Pro com diferentes limites de armazenamento, número de carros e uploads. Reservamos o direito de modificar estes limites ou introduzir novos níveis de subscrição a qualquer momento.",
            },
            disclaimer: {
                title: "5. Isenções de Responsabilidade e Precisão",
                description: "O MyCarCosts é uma ferramenta de informação e organização. Não fornecemos certificações oficiais de estado do veículo. Os dados de recibos analisados por IA devem ser sempre verificados pelo utilizador quanto à precisão.",
            },
            liability: {
                title: "6. Limitação de Responsabilidade",
                description: "O MyCarCosts é fornecido 'tal como está'. Não somos responsáveis por quaisquer problemas mecânicos, perdas financeiras ou imprecisões de dados resultantes da utilização da nossa aplicação.",
            },
            termination: {
                title: "7. Rescisão",
                description: "Pode deixar de utilizar o serviço e eliminar os seus dados a qualquer momento. Reservamos o direito de suspender ou encerrar contas que violem estes termos ou apresentem comportamento abusivo.",
            },
        },
    },
            audit: {
        hero: {
            badge: 'New: Protection Tool',
            title: 'Consult the Oracle.',
            subtitle: 'Stop second-guessing your mechanic. Paste your quote, describe the noise, or upload a photo. Get a direct, logic-based verdict in 60 seconds.',
            cta: 'Consult the Oracle',
            smallPrint: '100% Private. No credit card required.',
            walletSecurity: 'AI-Powered Security for Your Wallet'
        },
        demo: {
            title: 'Audit Results',
            verdictSell: 'Verdict: SELL',
            repairVsValue: 'Repair vs Value',
            cashGapSavings: 'Cash Gap to Replace',
            savingsValue: '$3,200 Savings',
            roiStrategyTitle: 'ROI Strategy',
            roiStrategyText: 'Investing $2,100 into a deteriorating $4,500 asset is a negative ROI. Replacing with a 2018 model now saves you $3,200 in long-term equity.',
            benefitsTitle: 'Stop Guessing. Master Your Car\'s ROI.',
            ctaSubtext: 'Stop guessing. Put your car\'s costs into logic-driven perspective.'
        },
        form: {
            uploadTitle: 'Photos or Documents (Optional)',
            uploadDesc: 'Upload a photo of your quote or just a picture of the problem area.',
            emailLabel: 'Email Address',
            emailPlaceholder: 'Where to send your report?',
            carLabel: 'Car Model',
            carPlaceholder: 'e.g. 2018 BMW X5 TDI 2.0 sedan',
            descLabel: 'Describe the problem',
            descPlaceholder: 'Paste your mechanic quote, describe the noise, or tell us the problem...',
            submit: 'Consult the Oracle',
            submitting: 'Processing...',
            successTitle: 'Quote Received!',
            successDesc: 'Our AI agents are analyzing your data. You will receive a detailed report at {email} within 60 seconds.',
            errorNoFiles: 'Please provide a description or upload a file.',
            errorNoEmail: 'Please enter your email address.',
            verifiedBy: 'Verified by Double-Agent Protocol'
        },
        progress: {
            analyzing: 'Analysis in progress...',
            scanning: 'Scanning Documents',
            checking: 'Checking Market Data',
            roi: 'ROI Calculations',
            finalizing: 'Finalizing Report',
            lightningTitle: 'First Look Verdict',
            lightningBadge: 'LIGHTNING ANALYSIS',
            firstImpression: 'First Impression',
            checkEmail: 'Check your email in 60 seconds',
            anotherAudit: 'Audit Another Situation',
            statusDesc: 'Our Double-Agent system is scrutinizing your data. The final report will be sent to your email.'
        },
        valueProps: {
            negotiation: {
                title: 'ROI Analysis',
                desc: 'Stop overpaying for labor. Get data-backed arguments for real repair times.'
            },
            peace: {
                title: 'Verdict in 60s',
                desc: 'Know for sure if your mechanic is honest about repairs or trying to "bloat" the bill.'
            },
            scams: {
                title: 'Avoid Common Scams',
                desc: 'Our database found that the average quote in big city dealerships is padded by 22% for "consultation" fees that aren\'t necessary.'
            },
            technical: {
                title: 'Replacement Logic',
                desc: 'We calculate the "Cash Gap" — the true cost of fixing your car versus replacing it with something reliable.'
            }
        },
        cta: {
            title: 'Stop dumping cash into a car that isn’t worth it.',
            button: 'Audit the Situation Now'
        },
        howItWorks: {
            title: 'How It Works',
            subtitle: 'The "Double-Agent" verification system ensures you get facts, not fluff.',
            extract: {
                title: 'Data Intake',
                desc: 'We analyze your situation and car model, factoring in mileage and historical maintenance trends.'
            },
            analyze: {
                title: 'Market Analysis',
                desc: 'Our AI compares repair costs against current market valuations and model reliability scores.'
            },
            audit: {
                title: 'ROI Calculation',
                desc: 'We calculate the financial gap between fixing your current vehicle and moving to a better one.'
            },
            verdict: {
                title: 'The Verdict',
                desc: 'You receive a clear "Repair or Sell" report with logic-driven strategy and priority action items.'
            }
        },
        results: {
            priceRealityCheck: 'Price Reality Check',
            roadmapTitle: 'What breaks next?',
            roadmapBadge: 'Roadmap Teaser',
            unlockFullReport: 'Unlock Full Forensic Audit',
            realWorldInsights: 'Real-World Insights',
            oracleAdvice: 'Real Advice from the Oracle',
            oracleAdviceSub: 'See how our AI helps real people navigate complex car problems every day.',
            readFullAudit: 'Read Full Audit',
            potentialSaving: 'Potential Saving',
            getYourOwn: 'Get your own Oracle Audit',
            savingsPotentialFound: 'Savings Potential Found',
            negotiationScript: 'Negotiation Script'
        },
        caseStudy: {
            backToAudit: 'Back to Audit',
            oracleCaseStudy: 'The Oracle Case Study',
            realUserQuestion: 'The Real User Question',
            officialAudit: 'Official Oracle Audit',
            fullReport: 'Full Resolution Report',
            economicImpact: 'Economic Impact',
            startYourAudit: 'Start Your Own Audit',
            moreAudits: 'More Real-World Audits',
            sharingIsCaring: "Sharing is caring. Save someone else's wallet.",
            poweredBy: 'Powered by MyCarCosts Double-Agent Intelligence'
        }
    },
    jarvis: {
        title: 'Jarvis',
        subtitle: 'AI Garage Agent',
        askJarvis: 'Ask Jarvis...',
        typing: 'Jarvis is thinking...',
        safetyWarning: 'Safety Warning',
        repairVerdict: 'Repair Verdict',
        diyFeasibility: 'DIY Feasibility'
    },
    repairMode: {
        oracleStatus: 'Oracle Status: {status}',
        verdictKeep: 'KEEP',
        verdictSell: 'SELL',
        verdictBorderline: 'BORDERLINE'
    }
};

